export default __webpack_public_path__ + "static/media/area-75.3c553e46.jpg";